module.exports = __webpack_public_path__ + "static/media/open-eye-icon.cfec2ab9.svg";